/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, September 15th 2022, 2:54:47 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import create from "zustand";
import { IntegrationProvider, IntegrationConnection } from "lib/schemas";
import { addOrUpdateItem, removeItem } from "lib/utils";

interface IIntegrationStore {
  integrationProviders: IntegrationProvider[];
  integrationConnections: IntegrationConnection[];
  populateIntegrationProviders: (providers: IntegrationProvider[]) => void;
  addIntegrationConnection: (connection: IntegrationConnection) => void;
  removeIntegrationConnection: (connectionId: IntegrationConnection["id"]) => void;
}

export const useIntegrationStore = create<IIntegrationStore>((set) => {
  return {
    integrationProviders: [],
    populateIntegrationProviders: (providers) => set((state) => ({ integrationProviders: providers })),
    integrationConnections: [],
    addIntegrationConnection: (connection) => {
      set((state) => ({
        integrationConnections: addOrUpdateItem(state.integrationConnections ?? [], connection, "id"),
      }));
    },
    removeIntegrationConnection: (connectionId) => {
      set((state) => ({
        integrationConnections: removeItem(state.integrationConnections, connectionId, "id"),
      }));
    },
  };
});

/** Selectors */
export const getIntegrationConnection = (connectionId: IntegrationConnection["id"]) => (state: IIntegrationStore) =>
  state.integrationConnections.find((connection) => connection.id === connectionId);
